// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ element, requiredRole, pageId }) => {
  const user = useUser();
  const location = useLocation();
  const params = useParams(); // for dynamic :id routes

  // 1. Not logged in
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // --- UPDATED ROLE-BASED ACCESS CHECK ---
  if (requiredRole) {
    // 1. Convert requiredRole to an array, even if it's a single string.
    //    If it's an array (e.g., ["admin", "superAdmin"]), use it directly.
    //    If it's a string (e.g., "superAdmin"), wrap it in an array.
    const requiredRolesArray = Array.isArray(requiredRole) ? requiredRole : [requiredRole];

    // 2. Check if the user's role is NOT included in the list of required roles.
    if (!requiredRolesArray.includes(user.role)) {
      return <Navigate to="/403" />;
    }
  }
  // ----------------------------------------

  // 3. Page-specific permission check (student + view/:id)
  if (user.role === 'student' && pageId) {
    const allowed = user.assigned_pages?.some(p => p.id === parseInt(pageId));
    if (!allowed) return <Navigate to="/403" />;
  }

  return element;
};

export default ProtectedRoute;